import { Instagram } from "lucide-react";
import { SITE } from "../config/siteConfig";

export default function Footer() {
  return (
    <footer id="impressum" data-testid="footer" className="bg-ink text-paper">
      <div className="mx-auto grid max-w-[1200px] gap-10 px-5 py-12 md:grid-cols-2 md:px-10 md:py-16">
        <div>
          <div className="flex items-center gap-2">
            <img
              src="/images/Hitstube_Discokugel.webp?v=2"
              alt=""
              aria-hidden="true"
              width={1361}
              height={1155}
              className="h-6 w-6"
            />
            <span className="font-display text-xl tracking-tight">HITSSTUBE</span>
          </div>
          <p className="leading-relaxed text-paper/70">OLMA Afterparty</p>
          <p className="mt-2 leading-relaxed text-paper/70">
            Waaghaus am Marktplatz St. Gallen
          </p>
          <p className="mt-2 leading-relaxed text-paper/70">
            Freitag &amp; Samstag, 19:00 Uhr bis 02:00 Uhr
          </p>
          <a
            data-testid="footer-instagram"
            href={SITE.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-paper/80 underline decoration-brand-red underline-offset-4 transition-colors duration-200 hover:text-paper"
          >
            <Instagram className="h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" />
            @hitsstube auf Instagram
          </a>
        </div>
        <div>
          <h3 className="font-display text-lg">Impressum</h3>
          <address className="mt-4 not-italic leading-relaxed text-paper/85">
            <p>{SITE.organizer.name}</p>
            <p>{SITE.organizer.street}</p>
            <p>{SITE.organizer.city}</p>
            <p className="mt-2">
              <span className="text-paper/60">Reservationen: </span>
              <a
                data-testid="footer-email"
                href={`mailto:${SITE.email}`}
                className="underline decoration-brand-red underline-offset-4 transition-colors duration-200 hover:text-paper"
              >
                {SITE.email}
              </a>
            </p>
          </address>
        </div>
      </div>
      <div className="border-t border-paper/15">
        <div className="mx-auto flex max-w-[1200px] flex-wrap items-center justify-between gap-3 px-5 py-5 text-sm text-paper/60 md:px-10">
          <p>© Kult AG · Hitsstube</p>
          <div className="flex items-center gap-5">
            <a
              href="#impressum"
              data-testid="footer-impressum-link"
              className="transition-colors duration-200 hover:text-paper"
            >
              Impressum
            </a>
            {SITE.privacyUrl && (
              <a
                href={SITE.privacyUrl}
                data-testid="footer-privacy-link"
                className="transition-colors duration-200 hover:text-paper"
              >
                Datenschutz
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
